import React, { useState, useEffect } from 'react';

export default function InsulinDosePicker({ onDoseChange, initialDose = null }) {
  const [selectedDose, setSelectedDose] = useState(initialDose);

  // Update parent component when dose changes
  useEffect(() => {
    if (onDoseChange) {
      onDoseChange(selectedDose);
    }
  }, [selectedDose, onDoseChange]);

  const handleDoseClick = (dose) => {
    setSelectedDose(dose);
  };

  const buttonStyle = {
    padding: '12px 16px',
    border: '2px solid #43ea5e',
    borderRadius: '8px',
    backgroundColor: 'white',
    color: '#43ea5e',
    cursor: 'pointer',
    fontSize: '16px',
    fontWeight: '500',
    transition: 'all 0.2s',
    minWidth: '60px',
    minHeight: '50px'
  };

  const selectedButtonStyle = {
    ...buttonStyle,
    backgroundColor: '#43ea5e',
    color: 'white',
    transform: 'scale(0.95)'
  };

  const buttonHoverStyle = {
    backgroundColor: '#e8f5e8',
    transform: 'scale(1.05)'
  };

  const selectedButtonHoverStyle = {
    backgroundColor: '#3ad654',
    transform: 'scale(0.95)'
  };

  return (
    <div style={{
      padding: '20px',
      backgroundColor: '#f8f9fa',
      borderRadius: '12px',
      border: '2px solid #e9ecef'
    }}>
      <h4 style={{
        margin: '0 0 16px 0',
        textAlign: 'center',
        color: '#43ea5e',
        fontSize: '16px'
      }}>
        Select Insulin Dose (units)
      </h4>
      
      {/* 5x2 Grid for doses 1-10 */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(5, 1fr)',
        gridTemplateRows: 'repeat(2, 1fr)',
        gap: '8px',
        maxWidth: '350px',
        margin: '0 auto'
      }}>
        {Array.from({ length: 10 }, (_, i) => {
          const dose = i + 1;
          const isSelected = selectedDose === dose;
          
          return (
            <button
              key={dose}
              onClick={() => handleDoseClick(dose)}
              style={isSelected ? selectedButtonStyle : buttonStyle}
              onMouseOver={(e) => {
                if (isSelected) {
                  Object.assign(e.target.style, selectedButtonHoverStyle);
                } else {
                  Object.assign(e.target.style, { ...buttonStyle, ...buttonHoverStyle });
                }
              }}
              onMouseOut={(e) => {
                if (isSelected) {
                  Object.assign(e.target.style, selectedButtonStyle);
                } else {
                  Object.assign(e.target.style, buttonStyle);
                }
              }}
            >
              {dose}
            </button>
          );
        })}
      </div>

      {/* Selection indicator */}
      <div style={{
        marginTop: '12px',
        textAlign: 'center',
        fontSize: '12px',
        color: '#666',
        minHeight: '16px'
      }}>
        {selectedDose ? `Selected: ${selectedDose} units` : 'No dose selected'}
      </div>
    </div>
  );
}
